"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var sanitized_render_1 = require("../../components/sanitized_render");
// this class allows us to conditionally parse Markdown
// because some components are used by LP and have Markdown
// text stored on them. Once we migrate LP pages to the core
// CMS and backfill away the Markdown we can drop this class
var MarkdownOutput = /** @class */ (function (_super) {
    tslib_1.__extends(MarkdownOutput, _super);
    function MarkdownOutput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MarkdownOutput.prototype.render = function () {
        var Parser = this.props.markdownParser;
        if (Parser) {
            if (!this.props.text)
                return null;
            return (React.createElement(Parser, { className: this.props.className, text: this.props.text }));
        }
        if (!this.props.text && !this.props.textHtml)
            return null;
        return (React.createElement(sanitized_render_1.default, { className: this.props.className, html: this.props.textHtml || this.props.text, htmlTag: this.props.htmlTag, truncationHeight: this.props.truncationHeight, inlineTagsOnly: this.props.inlineTagsOnly, blacklistedTags: this.props.blacklistedTags }));
    };
    return MarkdownOutput;
}(React.Component));
exports.default = MarkdownOutput;
//# sourceMappingURL=markdown_output.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/cms/components/markdown_output.js
// module id = tOPZ
// module chunks = 20 21